<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Multiselect from 'vue-multiselect'
import { Helper } from '@/mixin/helper'
import { GET_EMPLOYEES, UPDATE_EMPLOYEE } from '@/services/api/master/employees'

export default {
  page: {
    title: 'Master',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  mixins: [Helper],
  apollo: {
    employees: {
      query: GET_EMPLOYEES,
      result({ data, loading }) {
        if (!loading) {
          this.editableData = []
          this.totalRows = data.employees.employees.length
          this.filteredItems = data.employees.employees
          for (let i = 0; i < data.employees.employees.length; i++) {
            if (this.getUserId() == data.employees.employees[i].userId) continue
            this.editableData.push(data.employees.employees[i])
          }
        }
      },
    },
  },
  data() {
    return {
      phaseOneShow: false,
      editableData: [],
      selected: {
        masterEmployee: [],
      },
      selectedModel: {
        masterEmployee: [],
      },
      allSelected: {
        masterEmployee: false,
      },
      indeterminate: {
        masterEmployee: true,
      },
      employees: {
        employees: [],
      },

      position: null,
      department: null,
      workUnit: null,
      recruitment: null,
      merried: null,
      gender: null,
      employeeStatus: null,
      reasonInactive: null,
      fav: null,

      showFilter: 'all',
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      todocurrentPage: 1,
      perPage: 10,
      todoperPage: 10,
      pageOptions: [10, 25, 50, 100],
      todoOptions: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      show_model: null,
      defaultField: [
        'fullname',
        'email',
        'department',
        'unit',
        'position',
        'recruitedAt',
        'isActive',
      ],
      status: '',
      show: [
        { key: 'employeeIdentifier', label: 'Nomor Induk Pegawai' },
        { key: 'phoneNo', label: this.$t('master.list.driver.phone') },
        { key: 'gender', label: this.$t('master.list.driver.gender') },
        { key: 'email', label: 'Email' },
        { key: 'birthplace', label: 'Tempat Lahir' },
        { key: 'birthdate', label: 'Tanggal Lahir (Umur)' },
        { key: 'maritalStatus', label: 'Status Perkawinan' },
        { key: 'address', label: 'Alamat' },
        { key: 'department', label: this.$t('master.list.user.department') },
        { key: 'unit', label: this.$t('master.list.driver.workingUnit') },
        { key: 'position', label: this.$t('master.list.driver.position') },
        { key: 'joinOn', label: this.$t('master.list.driver.joinedDate') },
        { key: 'recruitedAt', label: this.$t('master.list.driver.placeOfRecruitment') },
        { key: 'isEmployee', label: 'Jenis Karyawan' },
        { key: 'isActive', label: this.$t('master.list.driver.status') },
      ],
      isAddFavorit: false,
      addFavorit: null,
      showModal: false,
      masterEmployee: [
        {
          key: 'check',
          thClass: 'mc-table--30',
          sortable: false,
        },
        {
          key: 'fullname',
          label: this.$t('master.list.driver.name'),
          sortable: true,
        },
        {
          key: 'employeeIdentifier',
          label: 'Nomor Induk Pegawai',
          sortable: true,
        },
        {
          key: 'phoneNo',
          label: this.$t('master.list.driver.phone'),
          sortable: true,
        },
        {
          key: 'gender',
          label: 'Jenis Kelamin',
          sortable: true,
        },
        {
          key: 'email',
          label: 'Email',
          sortable: true,
        },
        {
          key: 'birthplace',
          label: 'Tempat Lahir',
          sortable: true,
        },
        {
          key: 'birthdate',
          label: 'Tanggal Lahir (Umur',
          sortable: true,
        },
        {
          key: 'maritalStatus',
          label: 'Status Perkawinan',
          sortable: true,
        },
        {
          key: 'address',
          label: 'Alamat',
          sortable: true,
        },
        {
          key: 'department',
          label: this.$t('master.list.user.department'),
          sortable: true,
        },
        {
          key: 'unit',
          label: this.$t('master.list.driver.workingUnit'),
          sortable: true,
        },
        {
          key: 'position',
          label: this.$t('master.list.driver.position'),
          sortable: true,
        },
        {
          key: 'joinOn',
          label: 'Tanggal Kerja',
          sortable: true,
        },
        {
          key: 'recruitedAt',
          label: this.$t('master.list.driver.placeOfRecruitment'),
          sortable: true,
        },
        {
          key: 'isEmployee',
          label: 'Jenis Karyawan',
          sortable: true,
        },
        {
          key: 'isActive',
          label: this.$t('master.list.driver.status'),
          sortable: true,
        },
      ],
      filteredItems: [],
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    title() {
      // return this.$t("setting.list.userSetting.pengaturanPengguna");
      return this.$t('master.karyawan')
    },

    rows() {
      return this.employees.employees.length
    },

    /**
     * Todo list of records
     */
    todoList() {
      return this.todos.length
    },

    visibleFields() {
      if (this.show_model && this.show_model.length > 0) {
        var result = this.show_model.map((a) => a.key)

        return this.masterEmployee.filter(function (item) {
          return item.key == 'check' || item.key == 'fullname' || result.includes(item.key)
        })
      } else {
        var defaultField = this.defaultField
        return this.masterEmployee.filter(function (item) {
          return item.key == 'check' || item.key == 'fullname' || defaultField.includes(item.key)
        })
      }
    },
    filteredData() {
      var filter = this.showFilter
      if (filter != 'all') {
        return this.employees.employees.filter(function (item) {
          if (filter == 'active') {
            return item.isActive === true
          } else {
            return item.isActive === false
          }
        })
      }

      return this.employees.employees
    },
  },

  mounted() {
    // Set the initial number of items
    this.totalRows = this.employees.employees.length
    this.$apollo.queries.employees.refetch()
  },

  created() {
    for (let i = 0; i < this.employees.employees.length; i++) {
      this.selectedModel.masterEmployee.push(false)
    }

    this.$watch('selected.masterEmployee', (newValue) => {
      if (newValue.length === 0) {
        this.indeterminate.masterEmployee = false
        this.allSelected.masterEmployee = false
      } else if (newValue.length == this.editableData.length) {
        this.indeterminate.masterEmployee = false
        this.allSelected.masterEmployee = true
      } else {
        this.indeterminate.masterEmployee = true
        this.allSelected.masterEmployee = false
      }
    })
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    todoFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.todoTotalRows = filteredItems.length
      this.todocurrentPage = 1
    },

    toggleAll(checked, param) {
      this.selectedModel[param] = []
      this.selected[param] = []
      if (checked) {
        for (let i = 0; i < this.editableData.length; i++) {
          this.selected[param].push(this.editableData[i])
          this.selectedModel[param][this.editableData[i].userId] = true
        }
        this.allSelected[param] = true
      } else {
        for (let i = 0; i < this.editableData.length; i++) {
          this.selectedModel[param].push(false)
          this.selectedModel[param][this.editableData[i].userId] = false
        }
        this.selected[param] = []
        this.allSelected[param] = false
      }
    },

    checkTable(event, data, param) {
      if (event) {
        this.selected[param].push(data.item)
      } else {
        var myIndex = this.selected[param].indexOf(data.item)
        if (myIndex !== -1) {
          this.selected[param].splice(myIndex, 1)
        }
      }

      if (this.selected.length == this.editableData.length) {
        this.allSelected.masterEmployee = true
      } else {
        this.allSelected.masterEmployee = false
      }
    },
    toSave() {
      for (let i = 0; i < this.tData.masterEmployee.length; i++) {
        this.tData.masterEmployee[i].type = 'data'
      }
    },
    add(param, obj) {
      this.tData[param].push(obj)
    },
    toDelete(param) {
      this.selected[param].sort()
      this.selected[param].reverse()
      this.selected[param].forEach((row) => {
        this.$delete(this.tData[param], row)
      })
      this.selected[param] = []
      this.selectedModel[param] = []

      this.indeterminate[param] = false
      this.allSelected[param] = false
      for (let i = 0; i < this.tData[param].length; i++) {
        this.selectedModel[param].push(false)
      }
    },

    onRowClicked(item) {
      this.$router.push({
        name: 'Master Employee Detail',
        params: { id: item.userId },
      })
    },

    changeStatus(status) {
      this.status = status
      if (this.selected.masterEmployee.length > 0) {
        this.showModal = true
      } else {
        this.$toast.error(`Minimal memilih satu atau lebih dari data di bawah.`)
      }
    },
    clearDelete() {
      this.allSelected.masterEmployee = false
      this.selectedModel.masterEmployee.forEach((element, index) => {
        this.selectedModel.masterEmployee[index] = false
      })
      this.selected.masterEmployee.splice(0, this.selected.masterEmployee.length)
    },
    toChangeStatus() {
      let promises = []
      for (let i = 0; i < this.selected.masterEmployee.length; i++) {
        promises.push(
          this.$apollo.mutate({
            mutation: UPDATE_EMPLOYEE,
            variables: {
              input: {
                userId: this.selected.masterEmployee[i].userId,
                oldData: {
                  isActive: this.selected.masterEmployee[i].isActive,
                },
                newData: {
                  isActive: this.status == 'Aktif' ? true : false,
                },
              },
            },
          })
        )
      }

      Promise.all(promises).then(() => {
        this.$toast.success(
          `Berhasil mengubah ${this.selected.masterEmployee.length} status karyawan.`
        )
        this.showModal = false
        this.$apollo.queries.employees.refetch()
        this.clearDelete()
      })
    },
    tableFilter(filter) {
      this.showFilter = filter
      this.filteredItems = this.filteredData
      this.totalRows = this.filteredData.length
    },
    totalTrue() {
      let total = this.selectedModel.masterEmployee.filter((c) => c === true)
      return total.length
    },
  },
  filters: {
    getDate: function (value) {
      var date = new Date(value)
      var day = date.getDate()
      var monthIndex = date.getMonth()
      var year = date.getFullYear()

      const monthNames = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Agu',
        'Sep',
        'Okt',
        'Nov',
        'Des',
      ]

      return day + ' ' + monthNames[monthIndex] + ' ' + year
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />

      <p class="mb-4">{{ $t('master.textKaryawan') }}</p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button
            @click="$router.push({ name: 'Master Employee Import' })"
            variant="outline-primary"
            class="ms-3"
          >
            <i class="mc-fa icon-outline_upload"></i> {{ $t('global.upload') }}
          </b-button>
          <b-dropdown
            right
            variant="outline-primary"
            menu-class="dropdown-menu-end"
            class="mc-btn-download"
            v-if="phaseOneShow"
          >
            <template v-slot:button-content>
              Unduh <i class="mdi mdi-chevron-down ps-2"></i>
            </template>
            <b-dropdown-item
              ><i class="bx bx-book-content align-middle pe-1"></i> Unduh Tabel
              Excel</b-dropdown-item
            >
            <b-dropdown-item
              ><i class="bx bx-book-content align-middle pe-1"></i> Unduh Tabel PDF</b-dropdown-item
            >
          </b-dropdown>
          <b-button
            @click="$router.push({ name: 'Master Home Page' })"
            variant="outline-primary"
            class="ms-3"
          >
            <i class="mc-fa icon-outline_arrow-left"></i> {{ $t('global.back') }}
          </b-button>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-6">
          <div class="mc-table-filter__status pb-4">
            <b-button
              :variant="showFilter == 'all' ? 'secondary' : 'light'"
              size="sm"
              class="me-2"
              @click="tableFilter('all')"
              >{{ $t('global.showAll') }}</b-button
            >
            <b-button
              :variant="showFilter == 'active' ? 'secondary' : 'light'"
              size="sm"
              class="me-2"
              @click="tableFilter('active')"
              >{{ $t('master.form.user.status.active') }}</b-button
            >
            <b-button
              :variant="showFilter == 'inactive' ? 'secondary' : 'light'"
              size="sm"
              class="me-2"
              @click="tableFilter('inactive')"
              >{{ $t('master.form.user.status.inactive') }}</b-button
            >
          </div>
        </div>

        <div class="col-md-6">
          <div class="mc-table-filter text-end">
            <a
              v-b-modal.modal-filter
              class="popup-form btn btn-outline-primary me-2 mc-btn-filter"
              href="javascript: void(0);"
              v-if="phaseOneShow"
            >
              <i class="mc-fa icon-outline_filter"></i> Filter
            </a>
            <b-dropdown
              variant="outline-primary"
              class="mx-2"
              v-if="selected.masterEmployee.length"
            >
              <template v-slot:button-content>
                {{ $t('master.form.user.status.update') }}
                <i class="mdi mdi-chevron-down"></i>
              </template>
              <b-dropdown-item @click="changeStatus('Aktif')">{{ $t('master.form.user.status.active') }}</b-dropdown-item>
              <b-modal
                v-model="showModal"
                title="Ubah Status"
                body-class="p-3"
                hide-footer
                size="md"
                centered
              >
                <form @submit.prevent="">
                  <div class="row">
                    <p>
                      Apakah anda yakin mengubah status data berikut menjadi
                      <b>{{ status }}</b> ?
                    </p>

                    <div class="table-responsive">
                      <table class="table table-bordered mb-0" size="sm">
                        <thead>
                          <tr></tr>
                        </thead>
                        <tbody>
                          <tr v-for="employee in selected.masterEmployee" :key="employee.imei">
                            <td>{{ employee.fullname }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="text-end pt-5 mt-3">
                    <b-button variant="outline-primary" class="mx-2" @click="showModal = false"
                      >Tidak</b-button
                    >
                    <b-button type="submit" variant="primary" class="ms-1" @click="toChangeStatus"
                      >Ya</b-button
                    >
                  </div>
                </form>
              </b-modal>
              <b-dropdown-item @click="changeStatus('Nonaktif')">{{ $t('master.form.user.status.inactive') }}</b-dropdown-item>
            </b-dropdown>

            <b-button variant="primary" @click="$router.push({ name: 'Master Employee Create' })">
              <i class="mc-fa icon-outline_plus"></i> {{ $t('global.addField') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-4 col-md-4 mc-row-check-wrapper">
            <h6 v-if="this.totalTrue()" class="mc-row-check">
              <span class="badge btn-success">{{ this.totalTrue() }}</span>
              {{ $t('global.selectedRows') }}.
              <a class="color-primary" @click="clearDelete">{{ $t('global.action.clearAll') }}</a>
            </h6>
          </div>

          <div class="col-sm-8 col-md-8 d-flex flex-row-reverse mc-table-view-wrapper">
            <div class="mc-table-view">
              <p class="mc-label">{{ $t('global.shown') }}</p>
              <multiselect
                v-model="show_model"
                :options="show"
                :multiple="true"
                :placeholder="$t('global.object.allColumn')"
                track-by="label"
                label="label"
              ></multiselect>
              <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                <label class="d-inline-flex align-items-center mc-table-view__search">
                  <i class="mc-fa fas fa-search"></i>
                  <b-form-input
                    v-model="filter"
                    type="search"
                    :placeholder="$t('global.search') + '...'"
                    class="ms-2"
                  ></b-form-input>
                </label>
              </div>
            </div>
          </div>
        </div>

        <!-- Table -->
        <div class="table-responsive my-3 border border-1">
          <b-table
            small
            show-empty
            sort-by="fullname"
            :fields="visibleFields"
            :items="filteredData"
            class="datatables"
            responsive="md"
            empty-table
            :empty-text="$t('global.emptyTable')"
            :empty-filtered-text="$t('global.emptyFilteredTable')"
            :busy="$apollo.queries.employees.loading"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #head(check)>
              <div class="form-check">
                <b-form-checkbox
                  @change="toggleAll($event, 'masterEmployee')"
                  v-model="allSelected.masterEmployee"
                  :indeterminate="indeterminate.masterEmployee"
                  :value="true"
                  :unchecked-value="false"
                ></b-form-checkbox>
              </div>
            </template>

            <template #cell(check)="data">
              <div class="form-check">
                <b-form-checkbox
                  @change="checkTable($event, data, 'masterEmployee')"
                  v-model="selectedModel.masterEmployee[data.item.userId]"
                  :value="true"
                  :unchecked-value="false"
                  :disabled="cannotDelete(data.item.userId)"
                ></b-form-checkbox>
              </div>
            </template>

            <template #cell(fullname)="data">
              <strong class="text-primary" @click="onRowClicked(data.item)">
                {{ data.item.fullname }}
              </strong>
            </template>

            <template #cell(birthdate)="data">
              {{ data.item.birthdate | getDate }}
            </template>

            <!-- TODO: Change it to locales -->
            <template #cell(gender)="data">
              <template v-if="data.item.gender == 'M'"> Male </template>
              <template v-if="data.item.gender == 'F'"> Female </template>
              <template v-if="data.item.gender == 'X'"> Unspecified / Other </template>
            </template>

            <!-- TODO: Change it to locales -->
            <template #cell(maritalStatus)="data">

              <template v-if="data.item.maritalStatus == 'M'"> Married </template>
              <template v-if="data.item.maritalStatus == 'S'"> Single </template>
              <template v-if="data.item.maritalStatus == 'D'"> Divorced </template>
              <template v-if="data.item.maritalStatus == 'X'"> Death Divorce </template>
            </template>

            <template #cell(department)="data">
              {{ data.item.position ? data.item.position.departmentName : 'No Department' }}
            </template>

            <template #cell(unit)="data">
              {{ data.item.position ? data.item.position.unitName : 'No Unit' }}
            </template>

            <template #cell(position)="data">
              {{ data.item.position ? data.item.position.name : '-' }}
            </template>

            <template #cell(joinOn)="data">
              {{ data.item.joinOn | getDate }}
            </template>

            <template #cell(isEmployee)="data">
              {{ data.item.isEmployee ? 'Internal' : 'External' }}
            </template>

            <template #cell(isActive)="data">
              <span class="mc-status mc-status--grey" v-if="!data.item.isActive"> {{ $t('master.form.user.status.inactive') }} </span>
              <span class="mc-status mc-status--green" v-else> {{ $t('master.form.user.status.active') }} </span>
            </template>

            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
          </b-table>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                {{ $t('global.shown') }}
                <b-form-select
                  class="form-select form-select-sm"
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                >
                </b-form-select>
                {{ $t('global.text.entries') }}.
                <p>
                  {{ $t('global.shown') }}&nbsp;<strong>{{
                    filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0
                  }}</strong
                  >&nbsp;{{ $t('global.until') }}&nbsp;<strong>{{
                    Math.min(filteredItems.length, currentPage * perPage)
                  }}</strong
                  >&nbsp;{{ $t('global.from') }}&nbsp;<strong>{{ filteredItems.length }}</strong
                  >&nbsp;{{ $t('global.text.entries') }}.
                </p>
              </label>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows == null ? rows : totalRows"
                  :per-page="perPage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
